import { render } from "./BlogView.vue?vue&type=template&id=bbd2b36c&scoped=true"
import script from "./BlogView.vue?vue&type=script&lang=js"
export * from "./BlogView.vue?vue&type=script&lang=js"

import "./BlogView.vue?vue&type=style&index=0&id=bbd2b36c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbd2b36c"]])

export default __exports__